export var fadedDiamondBackground = '$Bguzs';
export var diamondDarkBackground = '_3aoow';
export var positionYArrowButton = '_25Q4U';